export default "__VITE_ASSET__CP8PVs4N__"